const components = {
    state: {
        resources: null
    },
    actions: {
        fetchResources({commit, state}) {
            return new Promise((resolve, reject) => {
                this._vm.http.get("/v1/system/resources").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    if (state.resources) return resolve(state.resources)

                    commit('SET_RESOURCES', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
    },
    mutations: {
        SET_RESOURCES (state, resources) {
            state.resources = resources
        }
    },
    getters: {
        getResources(state) {
            return state.resources
        }
    }
  }

export default components;